import { render, staticRenderFns } from "./TarifsGrille.vue?vue&type=template&id=23059e8c&scoped=true&"
import script from "./TarifsGrille.vue?vue&type=script&lang=ts&"
export * from "./TarifsGrille.vue?vue&type=script&lang=ts&"
import style0 from "./TarifsGrille.vue?vue&type=style&index=0&id=23059e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23059e8c",
  null
  
)

export default component.exports